$('.magicline-list').each((i, e) => {
    let $el, leftPos, newWidth
    let list = $(e);
    let $magicLine = $('<span>', { class: 'magicline'}).appendTo(list)
    let $activeItem = $('.active', list)
    let defaultLeft  = $activeItem.length ? $('.active', list).position().left : 0
    let defaultWidth = $activeItem.length ? $activeItem.outerWidth() : 0

    $magicLine.css({ left: defaultLeft, width: defaultWidth })

    $('a', list).hover(function() {
        $el = $(this)
        leftPos  = $el.position().left
        newWidth = $el.outerWidth()
        $magicLine.stop().css({ left: leftPos, width: newWidth })
    }, function() {
        $magicLine.stop().css({ left: defaultLeft, width: defaultWidth })
    })
})